import { FEATURES } from "./constants";

export const PUBLIC_ROUTE = "__public__";

const PUBLIC_ROUTES = {
    updateprofile: true,
    "access-denied": true,
    setup: true,
    offline: true,

    tax: true,
    outlet: true,

    "revenue-management": true,
    "revenue-management/dynamic-pricing": true,
    "revenue-management/channel-performance": true,
    "revenue-management/rules": true,

    "settings/booking-engine": true,
};

const ROUTE_FEATURE_MAP = {
    dashboard: FEATURES.DASHBOARD,
    reservations: FEATURES.RESERVATIONS,
    draft: FEATURES.DRAFT,
    reservation: FEATURES.RESERVATIONS,
    guestinfo: FEATURES.GUEST_MANAGEMENT,
    "crm/guest-directory": FEATURES.CRM_GUEST_DIRECTORY,
    "crm/ota-to-direct": FEATURES.CRM_OTA_CONVERSION,
    "crm/guests": FEATURES.CRM_GUEST_PROFILE,
    "check-in": FEATURES.CHECK_IN,
    "check-out": FEATURES.CHECK_OUT,
    arrival: FEATURES.CHECK_IN,
    departure: FEATURES.CHECK_OUT,
    "room-management": FEATURES.ROOM_MANAGEMENT,
    "room-view": FEATURES.ROOM_MANAGEMENT,
    facilitysettings: FEATURES.HOTEL_SETTINGS,
    "facilitysettings/addroomtype": FEATURES.ROOM_MANAGEMENT,
    "facilitysettings/floorview": FEATURES.ROOM_MANAGEMENT,

    housekeeping: FEATURES.HOUSEKEEPING_TASKS,

    laundry: FEATURES.LAUNDRY_OPERATIONS,
    "laundry/orders": FEATURES.LAUNDRY_OPERATIONS,
    "laundry/request": FEATURES.LAUNDRY_REQUESTS,
    "laundry/ticket": FEATURES.LAUNDRY_OPERATIONS,
    "laundry/scan": FEATURES.LAUNDRY_OPERATIONS,
    "laundry/dispatch": FEATURES.LAUNDRY_VENDOR,
    "laundry/complaints": FEATURES.LAUNDRY_COMPLAINTS,
    "laundry/cost-recovery": FEATURES.LAUNDRY_NON_REVENUE,
    "laundry/master": FEATURES.LAUNDRY_MASTER,
    "laundry/vendors": FEATURES.LAUNDRY_VENDOR,
    "laundry/vendor-invoices": FEATURES.LAUNDRY_VENDOR,
    "laundry/settings": FEATURES.LAUNDRY_CONFIG,
    "laundry-revenue-report": FEATURES.LAUNDRY_REPORTS,
    "laundry-tat-report": FEATURES.LAUNDRY_REPORTS,
    "laundry-outstanding-report": FEATURES.LAUNDRY_REPORTS,
    "laundry-vendor-report": FEATURES.LAUNDRY_REPORTS,
    "laundry-nonrevenue-report": FEATURES.LAUNDRY_REPORTS,
    "housekeeping-tasks": FEATURES.HOUSEKEEPING_TASKS,

    "customer-charges": FEATURES.CHARGE_POSTING,
    "charges-postings": FEATURES.CHARGE_POSTING,
    "charges-posting": FEATURES.CHARGE_POSTING,
    "paid-out": FEATURES.PAID_OUT,
    "guest-disbursement": FEATURES.GUEST_DISBURSEMENT,
    payment: FEATURES.PAYMENTS,
    invoice: FEATURES.BILLING,
    "provisional-bill": FEATURES.BILLING,

    "sales-report": FEATURES.SALES_REPORT,
    "gst-report": FEATURES.GST_REPORT,
    "foreigner-report": FEATURES.FOREIGNER_REPORT,
    "occupancy-report": FEATURES.OCCUPANCY_REPORT,
    "cancellation-report": FEATURES.CANCELLATION_REPORT,
    "guest-report": FEATURES.GUEST_REPORT,
    "collection-report": FEATURES.COLLECTION_REPORT,
    "refund-report": FEATURES.REFUNDS,
    reports: FEATURES.OCCUPANCY_REPORT,
    "housekeeping-report": FEATURES.HOUSEKEEPING_REPORT,

    "night-audit": FEATURES.NIGHT_AUDIT,
    "night-audit-process": FEATURES.NIGHT_AUDIT,
    "night-audit-report": FEATURES.NIGHT_AUDIT_REPORT,
    "night-audit-operational-report": FEATURES.NIGHT_AUDIT_OPERATIONAL_REPORT,

    settings: FEATURES.HOTEL_SETTINGS,
    notification: FEATURES.NOTIFICATION_SETTINGS,
    "rate-plan": FEATURES.RATE_PLAN,

    "user-management": FEATURES.USER_MANAGEMENT,
    "role-management": FEATURES.ROLE_MANAGEMENT,
    "audit-management": FEATURES.AUDIT_MANAGEMENT,

    "employee-management": FEATURES.STAFF_MANAGEMENT,
    employee: FEATURES.STAFF_MANAGEMENT,

    asset: FEATURES.INVENTORY_ITEMS,
    "asset-management": FEATURES.INVENTORY_ITEMS,

    booking: FEATURES.RESERVATIONS,
    enquiry: FEATURES.RESERVATIONS,
    event: FEATURES.RESERVATIONS,
    channel: FEATURES.RESERVATIONS,
    "channel-management": FEATURES.CHANNEL_MANAGEMENT,

    "customer-support": FEATURES.CUSTOMER_SUPPORT,

    coupons: FEATURES.COUPONS,
    "coupons/guest-offers": FEATURES.GUEST_OFFERS,

    "settings/booking-engine": FEATURES.BOOKING_ENGINE_CONFIG,

    "tutorial-management": FEATURES.TUTORIAL_MANAGEMENT,
    "tutorial-view": FEATURES.TUTORIAL,

    "transaction-types": FEATURES.APPROVAL_WORKFLOW,
    "approval-queue": FEATURES.AUTHORIZATION_PROCESSING,

    admin: FEATURES.ADMIN_DASHBOARD,
};

export const resolveFeatureFromPath = (pathname) => {
    if (!pathname) return null;

    const segments = pathname
        .replace(/^\//, "")
        .split("/")
        .filter((segment) => segment && !segment.startsWith(":"));

    const lookup = (candidate) => {
        if (PUBLIC_ROUTES[candidate]) return PUBLIC_ROUTE;
        if (ROUTE_FEATURE_MAP[candidate] !== undefined) {
            return ROUTE_FEATURE_MAP[candidate];
        }
        return undefined;
    };

    for (let length = segments.length; length >= 1; length--) {
        for (let start = segments.length - length; start >= 0; start--) {
            const hit = lookup(segments.slice(start, start + length).join("/"));
            if (hit !== undefined) return hit;
        }
    }

    return null;
};

export default ROUTE_FEATURE_MAP;
